/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

/*
* Pagination for Data Table list
* */

import Vue from 'vue'
import AppPagination from '../components/AppPagination.vue'

export default Vue.extend({
  components: {
    AppPagination
  },
  props: {
    page: {
      required: false,
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      itemsTotal: 0,
      rowsPerPage: 10,
      currentPage: 1
    }
  },
  computed: {
    pages (): number {
      return Math.ceil(this.itemsTotal / this.rowsPerPage)
    },
    paginationOffset (): number {
      return Number(this.rowsPerPage) * (Number(this.currentPage) - 1)
    }
  },
  mounted () {
    this.currentPage = Number(this.page)
  },
  methods: {
    fetchItems () {},
    onChangePage (event: any, pagerConfig: any = { newRoute: 'push' }) {
      // pagerConfig.newRoute :
      // push - default action
      // replace - don`t save router history
      // ignore - ignore any actions
      if (pagerConfig.newRoute !== 'ignore') {
        if (pagerConfig.newRoute === 'push') {
          this.$router.push({ query: { page: event.toString() } })
        }
        if (pagerConfig.newRoute === 'replace') {
          this.$router.replace({ query: { page: event.toString() } })
        }
      }
      this.currentPage = event
      this.fetchItems()
    },
    onChangePerPage (rowsPerPage: number) {
      this.rowsPerPage = rowsPerPage
      this.onChangePage(1)
    },
    checkPagination () {
      if (this.itemsTotal !== 0 && this.paginationOffset > this.itemsTotal) {
        this.onChangePage(1)
      }
    }
  }
})
